/**
 * 키보드 단축키 중앙 관리
 *
 * 구조: 각 단축키는 { key, ctrl, shift, alt, action, description } 형태
 *  - key: e.key 값 (소문자)
 *  - ctrl: true면 Ctrl/Cmd 필수, false면 Ctrl 없어야 함, undefined면 무관
 *  - shift: true면 Shift 필수, false면 Shift 없어야 함, undefined면 무관
 *  - action: 핸들러에서 참조하는 액션 ID
 *  - description: 사용자에게 표시할 설명
 *  - category: 분류
 */

// ========== 캔버스 제어 ==========
export const CANVAS_SHORTCUTS = [
  { key: '+', ctrl: true, shift: false, action: 'ZOOM_IN', description: '확대', displayKey: 'Ctrl + +' },
  { key: '=', ctrl: true, shift: false, action: 'ZOOM_IN', description: '확대', displayKey: 'Ctrl + +' },
  { key: '-', ctrl: true, shift: false, action: 'ZOOM_OUT', description: '축소', displayKey: 'Ctrl + -' },
  // Ctrl+마우스 휠, Space+드래그는 이벤트 리스너에서 직접 처리
];

// ========== 도구 전환 ==========
export const TOOL_SHORTCUTS = [
  { key: 'v', ctrl: false, action: 'TOOL_SELECT', description: '선택 도구', displayKey: 'V' },
  { key: 'l', ctrl: false, action: 'TOOL_LINE', description: '라인 도구', displayKey: 'L' },
  { key: 't', ctrl: false, action: 'TOOL_TEXT', description: '텍스트 도구', displayKey: 'T' },
  { key: 's', ctrl: false, action: 'TOOL_SHAPE', description: '도형 도구', displayKey: 'S' },
  { key: 'b', ctrl: false, action: 'TOOL_TABLE', description: '표 도구', displayKey: 'B' },
  { key: 'c', ctrl: false, action: 'TOOL_CHART', description: '차트 도구', displayKey: 'C' },
  { key: 'i', ctrl: false, action: 'TOOL_EYEDROPPER', description: '스포이트 (색상 추출)', displayKey: 'I' },
];

// ========== 요소 편집 ==========
export const EDIT_SHORTCUTS = [
  { key: 'z', ctrl: true, shift: false, action: 'UNDO', description: '실행 취소', displayKey: 'Ctrl + Z' },
  { key: 'y', ctrl: true, shift: false, action: 'REDO', description: '다시 실행', displayKey: 'Ctrl + Y' },
  { key: 'z', ctrl: true, shift: true, action: 'REDO', description: '다시 실행', displayKey: 'Ctrl + Shift + Z' },
  { key: 'g', ctrl: true, shift: false, action: 'GROUP', description: '그룹화', displayKey: 'Ctrl + G' },
  { key: 'g', ctrl: true, shift: true, action: 'UNGROUP', description: '그룹 해제', displayKey: 'Ctrl + Shift + G' },
  { key: 'delete', ctrl: false, action: 'DELETE', description: '삭제', displayKey: 'Delete' },
  { key: 'backspace', ctrl: false, action: 'DELETE', description: '삭제', displayKey: 'Backspace' },
  { key: 'c', ctrl: true, shift: false, action: 'COPY', description: '복사', displayKey: 'Ctrl + C' },
  { key: 'v', ctrl: true, shift: false, action: 'PASTE', description: '붙여넣기', displayKey: 'Ctrl + V' },
  { key: 's', ctrl: true, shift: false, action: 'SAVE', description: '저장', displayKey: 'Ctrl + S' },
  { key: 'arrowup', ctrl: false, shift: false, action: 'NUDGE_UP', description: '위로 1px 이동', displayKey: '↑' },
  { key: 'arrowdown', ctrl: false, shift: false, action: 'NUDGE_DOWN', description: '아래로 1px 이동', displayKey: '↓' },
  { key: 'arrowleft', ctrl: false, shift: false, action: 'NUDGE_LEFT', description: '왼쪽 1px 이동', displayKey: '←' },
  { key: 'arrowright', ctrl: false, shift: false, action: 'NUDGE_RIGHT', description: '오른쪽 1px 이동', displayKey: '→' },
  { key: 'arrowup', ctrl: false, shift: true, action: 'NUDGE_UP_10', description: '위로 10px 이동', displayKey: 'Shift + ↑' },
  { key: 'arrowdown', ctrl: false, shift: true, action: 'NUDGE_DOWN_10', description: '아래로 10px 이동', displayKey: 'Shift + ↓' },
  { key: 'arrowleft', ctrl: false, shift: true, action: 'NUDGE_LEFT_10', description: '왼쪽 10px 이동', displayKey: 'Shift + ←' },
  { key: 'arrowright', ctrl: false, shift: true, action: 'NUDGE_RIGHT_10', description: '오른쪽 10px 이동', displayKey: 'Shift + →' },
];

// ========== 텍스트 서식 ==========
export const TEXT_SHORTCUTS = [
  { key: ',', ctrl: true, shift: true, action: 'FONT_SIZE_DOWN', description: '글자 크기 줄이기', displayKey: 'Ctrl + Shift + <' },
  { key: '<', ctrl: true, shift: true, action: 'FONT_SIZE_DOWN', description: '글자 크기 줄이기', displayKey: 'Ctrl + Shift + <' },
  { key: '.', ctrl: true, shift: true, action: 'FONT_SIZE_UP', description: '글자 크기 키우기', displayKey: 'Ctrl + Shift + >' },
  { key: '>', ctrl: true, shift: true, action: 'FONT_SIZE_UP', description: '글자 크기 키우기', displayKey: 'Ctrl + Shift + >' },
  { key: 'c', ctrl: true, shift: true, action: 'COPY_FORMAT', description: '서식 복사', displayKey: 'Ctrl + Shift + C' },
  { key: 'v', ctrl: true, shift: true, action: 'PASTE_FORMAT', description: '서식 붙여넣기', displayKey: 'Ctrl + Shift + V' },
];

// ========== 표 (테이블) ==========
export const TABLE_SHORTCUTS = [
  { key: 'tab', ctrl: false, shift: false, action: 'TABLE_NEXT_CELL', description: '다음 셀로 이동', displayKey: 'Tab' },
  { key: 'tab', ctrl: false, shift: true, action: 'TABLE_PREV_CELL', description: '이전 셀로 이동', displayKey: 'Shift + Tab' },
  { key: 'm', ctrl: true, shift: false, action: 'TABLE_MERGE', description: '셀 병합', displayKey: 'Ctrl + M' },
  { key: 'm', ctrl: true, shift: true, action: 'TABLE_UNMERGE', description: '병합 해제', displayKey: 'Ctrl + Shift + M' },
];

// ========== 특수 키 (이벤트 리스너에서 직접 처리) ==========
export const SPECIAL_SHORTCUTS = [
  { action: 'PAN_DRAG', description: 'Space(홀드) + 드래그: 화면 이동', displayKey: 'Space + 드래그' },
  { action: 'PAN_WHEEL_DRAG', description: '마우스 휠 클릭 + 드래그: 화면 이동', displayKey: '휠 클릭 + 드래그' },
  { action: 'ZOOM_WHEEL', description: 'Ctrl + 마우스 휠: 확대/축소', displayKey: 'Ctrl + 휠' },
];

/**
 * 키 이벤트가 단축키 정의와 매칭되는지 확인
 */
export const matchShortcut = (e, shortcut) => {
  const keyMatch = e.key.toLowerCase() === shortcut.key.toLowerCase();
  const ctrlMatch = shortcut.ctrl === undefined || (shortcut.ctrl === (e.ctrlKey || e.metaKey));
  const shiftMatch = shortcut.shift === undefined || (shortcut.shift === e.shiftKey);
  const altMatch = shortcut.alt === undefined || (shortcut.alt === e.altKey);
  return keyMatch && ctrlMatch && shiftMatch && altMatch;
};

/**
 * 이벤트에 매칭되는 액션 찾기 (우선순위: TEXT > EDIT > CANVAS > TOOL)
 * shift+ctrl 조합이 ctrl 단독보다 우선
 */
export const findAction = (e, shortcutLists) => {
  for (const list of shortcutLists) {
    for (const shortcut of list) {
      if (matchShortcut(e, shortcut)) {
        return shortcut.action;
      }
    }
  }
  return null;
};

/**
 * 전체 단축키 목록 (UI 표시용)
 */
export const getAllShortcuts = () => [
  { category: '캔버스 제어', shortcuts: [...CANVAS_SHORTCUTS, ...SPECIAL_SHORTCUTS] },
  { category: '도구 전환', shortcuts: TOOL_SHORTCUTS },
  { category: '요소 편집', shortcuts: EDIT_SHORTCUTS },
  { category: '텍스트 서식', shortcuts: TEXT_SHORTCUTS },
  { category: '표 (테이블)', shortcuts: TABLE_SHORTCUTS },
];
